import { render, staticRenderFns } from "./chooseAreaItem.vue?vue&type=template&id=6ddc3a54"
import script from "./chooseAreaItem.vue?vue&type=script&lang=js"
export * from "./chooseAreaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports